import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { Avatar } from '@/components/Avatar'
import { SelectDisplayCurrencyModal } from '@/components/SelectDisplayCurrencyModal'
import { useTheme } from '@/hooks/useTheme'
import { useAppPreferencesStore } from '@/store'

interface SelectDisplayCurrencyProps {
  hasErrorOnLoadingCurrencies?: boolean
}

export const SelectDisplayCurrency: React.FC<SelectDisplayCurrencyProps> = ({
  hasErrorOnLoadingCurrencies = false,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { displayCurrency } = useAppPreferencesStore()

  // Не скрываем блок даже при ошибке загрузки валют
  if (hasErrorOnLoadingCurrencies) {
    return null
  }

  const handlePress = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      {/* CardItem.Root equivalent */}
      <BaseView
        row
        align="center"
        bgColor="background.cardItemRoot"
        rounded={24}
        px={16}
        py={16}
        gap={12}
        style={{
          cursor: 'pointer',
        }}
        onClick={handlePress}
      >
        {/* CardItem.Content equivalent */}
        <BaseView
          style={{
            flex: 1,
            width: '100%',
            flexDirection: 'column',
            gap: '6px',
            alignItems: 'flex-start',
          }}
        >
          <BaseText
            fontSize={18}
            fontFamily="semibold"
            color="label.description"
          >
            {t('translation:displayCurrency')}
          </BaseText>
        </BaseView>

        {/* CardItem.Footer equivalent */}
        <BaseView
          row
          align="center"
          gap={4}
          style={{
            alignItems: 'flex-end',
            paddingLeft: '4px',
          }}
        >
          <BaseView
            data-component="display-currency-item"
            row
            align="center"
            gap={4}
          >
            <Avatar
              fullSize={false}
              uri={displayCurrency?.img_url}
              size={20}
              name={displayCurrency?.isin || 'USD'}
            />
            <BaseText fontSize={18} fontFamily="bold" color="label.default">
              {displayCurrency?.isin || 'USD'}
            </BaseText>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18l6-6-6-6"
                stroke={theme.colors.label.description}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </BaseView>
        </BaseView>
      </BaseView>

      {/* Modal */}
      <SelectDisplayCurrencyModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  )
}
